import SiteFooter from '../../../b2c/layout/SiteFooter/SiteFooter';
import { FooterData, StoreContext } from '../../data/model';
import ContactSection from './ContactSection/ContactSection';
import Copyright from './Copyright/Copyright';
import css from './Footer.css';
import LinkList from './LinkList/LinkList';
import PaymentOptionList from './PaymentOptionList/PaymentOptionList';
import SocialMediaList from './SocialMediaList/SocialMediaList';

interface FooterProps {
  data: FooterData;
  homeUrl: string;
  storeContext: StoreContext;
}

// TODO: Remove after footer update in all stores
const Footer = ({ data, homeUrl, storeContext }: FooterProps) => {
  return data.displayNewFooter ? (
    <SiteFooter
      brand={data.brand}
      contactEmail={storeContext.contactEmail}
      copyright={data.copyright}
      groupAddress={data.groupAddress}
      homeUrl={homeUrl}
      links={data.links}
      localAddress={storeContext.localAddress}
      storeDisplayName={storeContext.store.displayName}
      tagline={data.tagline}
      taxNumber={storeContext.taxNumber}
    />
  ) : (
    <footer className={css.container}>
      <div className={css.inner}>
        <LinkList className={css.linkList} items={data.links} />
        <SocialMediaList
          className={css.socialMedia}
          blogLink={data.socialMedia.blogLink}
          facebookLink={data.socialMedia.facebookLink}
          instagramLink={data.socialMedia.instagramLink}
          linkedInLink={data.socialMedia.linkedInLink}
          pinterestLink={data.socialMedia.pinterestLink}
          followUsText={data.socialMedia.followUsText}
        />
        <ContactSection
          className={css.contact}
          address={data.address}
          emailAddress={data.emailAddress}
          phoneNumber={data.phoneNumber}
        />
        <div className={css.end}>
          <Copyright
            className={css.copyright}
            allRightsReservedText={data.copyright.allRightsReservedText}
            copyrightNoticeText={data.copyright.copyrightNoticeText}
          />
          {data.paymentInformation && <PaymentOptionList items={data.paymentInformation.options} />}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
